<template>
    <div class="exhibitor-files-page page">
        <PageBlocked v-if="isBlocked" :blockRole="blockRole" />
        <div v-else-if="isBlocked !== null">
            <ButtonBack />
            <v-skeleton-loader 
                v-if="this.isLoading" 
                v-bind="attrs" 
                type="card" 
            />
            <div v-else-if="exhibitor" class="exhibitor-files-page__content mt-8">
                <h3 class="exhibitor-files-page__content-title">
                    {{ exhibitor.partner_name }} Files
                </h3>
                <ExhibitorFile 
                    v-for="file in exhibitor.uploads"
                    :key="file.upload_id"
                    :file="file"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import ExhibitorFile from '@/components/Event/ExhibitorFile'
import Block from '@/mixins/Block.js'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        ButtonBack,
        ExhibitorFile
    },
    mixins: [Block],
    data() {
        return {
            attrs: {
                elevation: 0,
                class: 'pt-7',
            }
        }
    },
    methods: {
        ...mapActions('event', ['getExhibitorById'])
    },
    computed: {
        ...mapGetters('event', ['isLoading', 'exhibitor'])
    },
    created() {
        if (!this.exhibitor || (this.exhibitor && this.exhibitor.partner_id !== +this.$route.params.id)) {
            this.getExhibitorById(+this.$route.params.id)
        } 
    }
}
</script>
<style lang="scss">
.exhibitor-files-page {
    font-family: Montserrat, sans-serif;

    &__content {
        padding: 30px;
        border-radius: 10px;
        background-color: #fff;

        &-title {
            color: #4A4A4A;
            font-size: 24px;
            font-weight: 700;
            line-height: 29.26px;
            margin-bottom: 16px;
        }
    }
}
</style>